module.exports = __webpack_public_path__ + "img/dia1.50a92e6e.jpg";